import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { ComplianceReport } from "../models/compliance.model";
import { IssuesService } from "../../common/services/issues.service";
import { LoaderService } from "../../common/services/loader.service";
import { Dialog, DialogButton } from "../../core/models/dialog.model";
import { DynamicDialogService } from "../../core/services/dynamic-dialog.service";


@Injectable({
  providedIn: 'root'
})
export class ComplianceReportResolver   {

    private _dialogMessage = "Unable to resolve report ID [XXX].";
    private _dialog: Dialog = new Dialog("", [new DialogButton("Cancel", false, () => { this.close(); })]);
    private _id: string;

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): ComplianceReport | Observable<ComplianceReport> | Promise<ComplianceReport> {
        this.loader.toggleLoader(true);
        this._id = route.params.id;
        return this.issuesService.getComplianceReport(this._id).pipe(
            catchError((err) => {
                console.error(err);
                this.showError();
                return of(null);
            }),
            tap((data: ComplianceReport) => {                
                this.loader.toggleLoader(false);
            })
        )
    }

    close(): void {
        this.loader.toggleLoader(false);
    }

    showError(): void {
        this._dialog.message = this._dialogMessage.replace("[XXX]", this._id);
        this._dialog.toggleDialog(true);
        this.dialogService.updateDialog(this._dialog);
    }

    constructor(private issuesService: IssuesService, private loader: LoaderService, private dialogService: DynamicDialogService) { }
}
